import { render, staticRenderFns } from "./PaymentFormCustomer.vue?vue&type=template&id=4fc56650&"
import script from "./PaymentFormCustomer.vue?vue&type=script&lang=js&"
export * from "./PaymentFormCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports